// Copyright (c) 2015, YangtzeSoft Technologies. and Contributors
// MIT License. See license.txt

// for translation
yangtze._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = yangtze._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = yangtze._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = yangtze._;

yangtze.get_languages = function () {
	if (!yangtze.languages) {
		yangtze.languages = [];
		$.each(yangtze.boot.lang_dict, function (lang, value) {
			yangtze.languages.push({ label: lang, value: value });
		});
		yangtze.languages = yangtze.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return yangtze.languages;
};
